/**
 * Syncs Recharge widget purchase option into Dawn's product form
 * so theme ATC (Ajax / cart drawer) sends the selected selling_plan.
 */
(function () {
  const FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
  const INPUT_CLASS = 'product-selling-plan-id';

  function queryDeep(root, selector) {
    if (!root) return [];
    const matches = [];
    if (root.querySelectorAll) {
      try {
        matches.push(...root.querySelectorAll(selector));
      } catch (e) {
        /* invalid selector in some roots */
      }
    }
    const treeWalkerRoots = root.querySelectorAll ? root.querySelectorAll('*') : [];
    treeWalkerRoots.forEach((el) => {
      if (el.shadowRoot) matches.push(...queryDeep(el.shadowRoot, selector));
    });
    return matches;
  }

  function firstValue(nodes, predicate) {
    for (const node of nodes) {
      const value = predicate(node);
      if (value != null && String(value).trim() !== '') return String(value).trim();
    }
    return '';
  }

  function readSellingPlan() {
    const onetime = queryDeep(
      document,
      'input[type="radio"]:checked[value="onetime"], input[type="radio"]:checked[value="one-time"], input[type="radio"]:checked[value="otp"]'
    );
    if (onetime.length) return '';

    const named = queryDeep(document, '[name="selling_plan"]').filter(
      (el) => !el.classList?.contains(INPUT_CLASS)
    );
    const checked = named.filter((el) => el.matches?.('select, input[type="hidden"], input:checked'));
    const fromNamed = firstValue(checked.length ? checked : named, (el) => el.value);
    if (fromNamed) return fromNamed;

    const dataNodes = queryDeep(
      document,
      '[data-selling-plan-id], [data-selling-plan], [data-selected-selling-plan-id]'
    );
    const fromData = firstValue(dataNodes, (el) => {
      return (
        el.getAttribute('data-selling-plan-id') ||
        el.getAttribute('data-selected-selling-plan-id') ||
        el.getAttribute('data-selling-plan') ||
        el.value
      );
    });
    if (fromData) return fromData;

    const subChecked = queryDeep(
      document,
      'input[type="radio"]:checked[value="subscription"], input[type="radio"]:checked[value="subscribe"]'
    );
    if (subChecked.length) {
      const frequency = queryDeep(
        document,
        'select[name="selling_plan"], select[data-selling-plan], [data-recharge-frequency] select'
      );
      const freqValue = firstValue(frequency, (el) => el.value);
      if (freqValue) return freqValue;
    }

    if (window.Recharge?.widget?.sellingPlanId) return String(window.Recharge.widget.sellingPlanId);
    if (window.Recharge?.sellingPlanId) return String(window.Recharge.sellingPlanId);

    return '';
  }

  function getForms() {
    return document.querySelectorAll(FORM_SELECTOR);
  }

  function ensureInput(form) {
    let input = form.querySelector(`input.${INPUT_CLASS}[name="selling_plan"]`);
    if (!input) {
      input = form.querySelector('[name="selling_plan"]');
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.className = INPUT_CLASS;
      form.appendChild(input);
    }
    return input;
  }

  function syncForm(form) {
    const plan = readSellingPlan();
    const input = ensureInput(form);
    input.value = plan;
    input.disabled = plan === '';
  }

  function syncAll() {
    getForms().forEach(syncForm);
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest?.(FORM_SELECTOR);
      if (form) syncForm(form);
    },
    true
  );

  document.addEventListener('change', (event) => {
    const t = event.target;
    if (!t) return;
    const name = (t.getAttribute && t.getAttribute('name')) || '';
    if (
      name === 'selling_plan' ||
      name.includes('recharge') ||
      name.includes('selling') ||
      t.closest?.('recharge-subscription-widget, [data-recharge-widget], .recharge-subscription-widget')
    ) {
      syncAll();
    }
  });

  let observerTimer;
  const observer = new MutationObserver(() => {
    clearTimeout(observerTimer);
    observerTimer = setTimeout(syncAll, 100);
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  document.addEventListener('shopify:section:load', syncAll);
})();
